import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import ReactDOMServer from "react-dom/server";
import axiosInstance from "../../axiosConfig";

// Définir des icônes personnalisées pour les motos et les voitures
const createIcon = (icon) => {
  return L.divIcon({
    html: ReactDOMServer.renderToString(icon),
    className: "", // Ajouter des classes personnalisées ici si nécessaire
    iconSize: [25, 25], // Ajuster la taille si nécessaire
  });
};

const carIcon = createIcon(
  <i className="ri ri-car-fill" style={{ fontSize: "25px", color: "red" }} />
);
const motoIcon = createIcon(
  <i
    className="ri ri-e-bike-2-fill"
    style={{ fontSize: "25px", color: "blue" }}
  />
);

const UpdateMapCenter = ({ position, shouldCenter }) => {
  const map = useMap();
  useEffect(() => {
    if (position && shouldCenter) {
      map.setView(position, 15);
    }
  }, [position, shouldCenter, map]);
  return null;
};

const MapComponent = (props) => {
  const [vehicles, setVehicles] = useState([]);
  const [vehicleSelected, setVehicleSelected] = useState([6.3659, 2.4125]); // Initialiser avec des coordonnées par défaut
  const [shouldCenter, setShouldCenter] = useState(false);

  useEffect(() => {
    const fetchVehicles = async () => {
      const position = await axiosInstance.get(`/driverposition/`);
      const positionFiltered = position.data.data.filter(
        (position) => position.latitude !== null && position.longitude !== null
      );
      setVehicles(positionFiltered);
      if (positionFiltered.length > 0) {
        const lastVehicle = positionFiltered[positionFiltered.length - 1];
        const lastPosition = [
          parseFloat(Number(lastVehicle.latitude)),
          parseFloat(Number(lastVehicle.longitude)),
        ];
        setVehicleSelected(lastPosition);
      }
    };

    fetchVehicles();
    const interval = setInterval(fetchVehicles, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleCenterMap = () => {
    setShouldCenter(true);
    setTimeout(() => setShouldCenter(false), 1000); // Reset the shouldCenter state after centering
  };

  document.title = props.t("Plan Chauffeurs / Livreurs | Takci");

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <button
        onClick={handleCenterMap}
        className="btn btn-sm text-light"
        style={{
          position: "absolute",
          bottom: "10px",
          right: "20px",
          backgroundColor: "#014c94",
          zIndex: 1000,
        }}
        title="Centrer sur la dernière position"
      >
        <i className="ri-fullscreen-exit-line"></i>
      </button>
      <MapContainer
        center={vehicleSelected}
        zoom={15}
        style={{ height: "100%", width: "100%" }}
        className="position-relative"
      >
        <UpdateMapCenter
          position={vehicleSelected}
          shouldCenter={shouldCenter}
        />
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {vehicles.map((vehicle) => (
          <Marker
            title={`Position de ${vehicle.first_name} ${vehicle.last_name}`}
            key={vehicle.user_id}
            position={[
              parseFloat(Number(vehicle.latitude)),
              parseFloat(Number(vehicle.longitude)),
            ]}
            icon={
              vehicle.type_engin && vehicle.type_engin === "Voiture"
                ? carIcon
                : motoIcon
            }
            eventHandlers={{
              add: (e) => {
                e.target.openPopup();
              },
            }}
          >
            <Popup>
              <b>
                {"Agent"} : {vehicle.first_name} {vehicle.last_name}
              </b>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

MapComponent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(MapComponent));
